var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2858 6.85707H22.8572V5.71422C22.8572 3.82393 21.319 2.28564 19.4287 2.28564H12.5715C10.6812 2.28564 9.14296 3.82393 9.14296 5.71422V6.85707H5.71439C5.08353 6.85707 4.57153 7.36907 4.57153 7.99993C4.57153 8.63079 5.08353 9.14279 5.71439 9.14279H26.2858C26.9167 9.14279 27.4287 8.63079 27.4287 7.99993C27.4287 7.36907 26.9167 6.85707 26.2858 6.85707ZM6.72353 27.5714C6.79896 28.7759 7.79782 29.7142 9.00468 29.7142H22.9955C24.2024 29.7142 25.2012 28.7759 25.2767 27.5714L26.2858 11.4285H5.71439L6.72353 27.5714ZM11.4287 6.85707H20.5715V5.71422C20.5715 5.0845 20.0584 4.57136 19.4287 4.57136H12.5715C11.9418 4.57136 11.4287 5.0845 11.4287 5.71422V6.85707Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.d9d67eb65ff6b1f1b0b2d3573ae67f1b.svg";
export { ForwardRef as ReactComponent };